import React from 'react';
import { STOCKS_DETAIL_PERMISSION } from 'pages/StocksDetail/utils/permissions';

const StocksDetailPage = React.lazy(() => import('pages/StocksDetail/StocksDetailPage.js'));
const StocksDetailProduct = React.lazy(() => import('pages/StocksDetail/StocksDetailProduct.js'));
const StocksDetailHistory = React.lazy(() => import('pages/StocksDetail/StocksDetailHistory.js'));
const ImeiInventoryPage = React.lazy(() => import('pages/StocksDetail/ImeiInventoryPage.jsx'));
const InventoryCostCorrectionPage = React.lazy(() => import('pages/StocksDetail/InventoryCostCorrectionPage.jsx'));
const InventoryTransferMonitorPage = React.lazy(() =>
  import('pages/StocksDetail/InventoryTransferMonitorPage.jsx'),
);
const InventorySummaryPage = React.lazy(() => import('pages/InventorySummary/InventorySummaryPage.jsx'));

const stocksDetailRoute = [
  {
    path: '/stocks-detail',
    exact: true,
    name: 'Danh sách tồn kho',
    function: STOCKS_DETAIL_PERMISSION.VIEW,
    component: StocksDetailPage,
  },
  {
    path: '/inventory-summary',
    exact: true,
    name: 'Tổng hợp tồn kho theo sản phẩm',
    allowLoggedIn: true,
    component: InventorySummaryPage,
  },

  {
    path: '/inventory-transfer-monitor',
    exact: true,
    name: 'Theo dõi tồn giữ & chuyển kho',
    function: [STOCKS_DETAIL_PERMISSION.TRANSFER_MONITOR_VIEW, STOCKS_DETAIL_PERMISSION.VIEW],
    any: true,
    component: InventoryTransferMonitorPage,
  },
  {
    path: '/stocks-detail/detail/:stocksId/:productId/:materialId',
    exact: true,
    name: 'Chi tiết tồn kho',
    function: STOCKS_DETAIL_PERMISSION.VIEW,
    component: StocksDetailProduct,
  },
  {
    path: '/stocks-detail/imei-inventory',
    exact: true,
    name: 'Quản lý tồn theo IMEI',
    function: STOCKS_DETAIL_PERMISSION.SALES_INVENTORY_VIEW,
    component: ImeiInventoryPage,
  },
  {
    path: '/stocks-detail/cost-correction',
    exact: true,
    name: 'Cập nhật giá vốn tồn kho',
    function: STOCKS_DETAIL_PERMISSION.INVENTORY_COST_CORRECTION,
    requireAssigned: true,
    component: InventoryCostCorrectionPage,
  },
  {
    path: '/stocks-detail/history/:productImeiCode',
    exact: true,
    name: 'Lịch sử lưu kho',
    function: [STOCKS_DETAIL_PERMISSION.VIEW, STOCKS_DETAIL_PERMISSION.SALES_INVENTORY_VIEW],
    any: true,
    component: StocksDetailHistory,
  },
  {
    path: '/stocks-detail/out-calculate-pricing',
    exact: true,
    name: 'Danh sách tồn kho',
    function: STOCKS_DETAIL_PERMISSION.COGS_CALCULATE,
    component: StocksDetailPage,
  },
];

export default stocksDetailRoute;
